import { paymentMethodEnum } from "../../../Enums/RegistrationEnum";

export function formatPaymentMethodLabel(method: string): string {
  if (!method) {
    return "—";
  }
  const label = (paymentMethodEnum as Record<string, string>)[method];
  return label ?? method;
}

export function formatCurrencyAmount(amount: number): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(amount);
}

export function formatToCurrency(amount: number | undefined): string {
  if (!amount) {
    return "-";
  }
  return formatCurrencyAmount(amount);
}

/** Always a dollar amount. Missing or invalid values display as $0.00. */
export function formatCurrencyOrZero(
  amount: number | null | undefined,
): string {
  const value =
    typeof amount === "number" && Number.isFinite(amount) ? amount : 0;
  return formatCurrencyAmount(value);
}

/** Meeting fee amount, or "no fee" when the event has no charge for that slot. */
export function formatFeeOrNoFee(amount: number | null | undefined): string {
  if (typeof amount !== "number" || !Number.isFinite(amount) || amount <= 0) {
    return "No fee";
  }
  return formatCurrencyAmount(amount);
}

export function feeHighlightClass(highlight: boolean): string {
  return highlight ? "text-secondary-dark" : "text-gray-400";
}
